import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function truncate(str, length = 100) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export function generateWhatsAppLink(message) {
  const phone = '919876543210'; // Replace with actual WhatsApp number
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${encodedMessage}`;
}

export function getProductWhatsAppMessage(product, category, brand) {
  return `Hi, I'm interested in ${product?.name || 'your products'}${category ? ` from ${category}` : ''}${brand ? ` by ${brand}` : ''}. Please share more details.`;
}

export function getCategoryWhatsAppMessage(category) {
  return `Hi, I'm interested in your ${category} collection. Please share the catalog and pricing.`;
}

export function getGeneralWhatsAppMessage() {
  return `Hi, I'm interested in becoming a wholesale partner with Passion of Aroma. Please share more details about your products and terms.`;
}
